module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/components/BattlesButton/images/hover.f77e332e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/BattlesButton/images/hover.png
// module id = 3061
// module chunks = 11